import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/nhan-su/ho-so'

// Lọc hồ sơ
export function locHoSo(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-ho-so`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy hồ sơ nhân viên
export function layHoSoNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/ho-so`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo hồ sơ nhân viên
export function taoHoSoNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-ho-so-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật hồ sơ nhân viên
export function capNhatHoSoNhanVien(userId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${userId}/cap-nhat-ho-so-nhan-vien`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tính toán trạng thái hồ sơ nhân viên
export function tinhToanTrangThaiHoSoNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/tinh-trang-ho-so/tinh-toan`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy trạng thái hồ sơ nhân viên
export function layTrangThaiHoSoNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/tinh-trang-ho-so`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo hàng loạt hồ sơ
export function taoHangLoatHoSo(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-hang-loat-ho-so`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật hàng loạt hồ sơ
export function capNhatHangLoatHoSo(params: any) {
  try {
    return axiosApi.put(`${BASE}/cap-nhat-hang-loat-ho-so`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa hàng loạt hồ sơ
export function xoaHangLoatHoSo(params: any) {
  try {
    return axiosApi.delete(`${BASE}/xoa-hang-loat-ho-so`, { data: params })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xuất dữ liệu nhân viên
export function xuatDuLieuNhanVien(params: any) {
  try {
    return axiosApi.post(`${BASE}/xuat-du-lieu-nhan-vien`, params, {
      responseType: 'blob',
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tải file mẫu import
export function taiFileMauImport() {
  try {
    return axiosApi.get(`${BASE}/tai-file-mau-import`, {
      responseType: 'blob',
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Import dữ liệu nhân viên
export function nhapDuLieuNhanVien(params: any) {
  try {
    return axiosApi.post(`${BASE}/import-du-lieu-nhan-vien`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
